import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { NotebookDisplayed } from '../../interfaces/notebook-displayed';
import { CommonModule } from '@angular/common';
import { OnInit, OnDestroy } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { NOTEBOOK_STATUS_LABELS } from '../../config/notebook-config';

@Component({
  standalone: true,
    selector: 'app-notebook-actions-menu',
    imports: [MatIconModule, MatMenuModule, CommonModule],
    templateUrl: './notebook-actions-menu.component.html',
    styleUrl: './notebook-actions-menu.component.css'
})
export class NotebookActionsMenuComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
 readonly notebookStatusLabels= NOTEBOOK_STATUS_LABELS;
  constructor(
  ) {}
  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

@Input() notebook!: NotebookDisplayed;
@Input() showDetails = true;
@Output() start = new EventEmitter<{ id: string, cpu: number }>();

@Output() stop = new EventEmitter<{ id: string; storage: number }>();

@Output() delete = new EventEmitter<string>();
@Output() details = new EventEmitter<string>();


startNotebook() {
  this.start.emit({ id: this.notebook.id, cpu: this.notebook.cpu });

}

stopNotebook() {
  const parsedStorage = Number(this.notebook.storage ?? 0);
  this.stop.emit({ id: this.notebook.id, storage: parsedStorage }); 
  //console.log("storage:", parsedStorage);
}

deleteNotebook() {
  this.delete.emit(this.notebook.id);
}

goToDetails() {
  this.details.emit(this.notebook.id);
}

}
